import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-260c3eb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Voltas", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Ainda não há dados gravados", -1))
const _hoisted_8 = [
  _hoisted_7
]

import { useStore } from '../store/tracker'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
// const formattedTrackers = store.formattedTrackers

return (_ctx: any,_cache: any) => {
  return (_unref(store).formattedTrackers.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).formattedTrackers, (data) => {
          return (_openBlock(), _createElementBlock("div", {
            key: data.uid
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, _toDisplayString(data.uid), 1),
              _createElementVNode("div", null, _toDisplayString(data.name), 1),
              _createElementVNode("div", null, _toDisplayString(data.elapsedTime), 1)
            ]),
            _hoisted_3,
            (data.laps && data.laps.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.laps, (lap, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "laps",
                      key: `${lap}_${key}`
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h6", null, _toDisplayString(key + 1), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("h6", null, _toDisplayString(lap), 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
}
}

})